import { HelperCore } from "@/common/dependencies";

export function formatFileSize(sizeInBytes) {
  if ((typeof sizeInBytes !== 'number' && !Number(sizeInBytes)) || sizeInBytes <= 0) {
    return 0;
  }
  if (sizeInBytes < 1024 * 1024) {
    return `${Math.round(sizeInBytes / 1024)}KB`;
  }
  return `${Math.round((sizeInBytes / (1024 * 1024)) * 10) / 10}MB`;
}
export const isAliUrl = (url) => {
  if(!url){
    return false;
  }
  return url.includes("https://cloud.zhaomi.cn/");
}
const DEFALUT_MINIFY_OPTIONS = {
  size : 10 * 1024 * 1024,
}
export const minifyAliImage = (fileInfo, options = true) => {
  // debug
  // console.log("minifyAliImage", fileInfo, options);

  const { url, size, width, height } = fileInfo;

  // 非阿里 CDN 图片
  if(!isAliUrl(url)){
    return url;
  }

  let needMinify = false;
  if(options === true){
    needMinify = true;
  }
  else {
    const mergeOptions = {
      ...DEFALUT_MINIFY_OPTIONS,
      ...options,
    }
    if(mergeOptions.size && size && size > mergeOptions.size){
      needMinify = true;
    }
    else if(mergeOptions.pixel && width && height && width * height > mergeOptions.pixel){
      needMinify = true;
    }
  }

  if(needMinify){
    const _url = HelperCore.getUrlWithOutParams(url);
    return `${_url}?x-oss-process=image/resize,l_600/quality,q_80`;
  }

  return url;
}
/**
 * 图片消息要求的图片 url
 *  1. ocr
 * @param {Object} fileInfo { url, size }
 * @returns 
 */
export const getImageMessageUrl = (fileInfo) => {
  return new Promise((resolve) => {
    HelperCore.getImageSize(fileInfo.url)
    .then(imageSize => {
      const url = minifyAliImage({...fileInfo, ...imageSize}, { pixel : 1048576, size : 10 * 1024 * 1024 });
      resolve(url);
    })
  })
}

export const typeOf = (o) => {
  if (o === null) return 'null';
  if (typeof o !== 'object') {
    return typeof o;
  } else {
    const toString = Object.prototype.toString;
    return toString.call(o).slice(8, -1).toLocaleLowerCase();
  }
}
